import {getRequest} from "../../httpClient";



export async function fetchAttendanceStatistics(token, groupBy = "year") {
    return  await getRequest(`/v3/event/statistics?groupBy=${groupBy}`, token)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}

export async function fetchFinanceStatistics(token, groupBy = "year") {
    return  await getRequest(`/v3/finance/statistics?groupBy=${groupBy}`, token)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}

export async function fetchFinanceProjection(token) {
    return  await getRequest(`/v3/finance/projection`, token)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}
